import React from 'react';

import { DatePickerReact } from '@common/react/components/UI/DatePickerReact/DatePickerReact';
import NativeDatepicker from '@common/react/components/base/DatePicker/NativeDatepicker';
import { useMobileView } from '@common/react/hooks/useMobileView';

interface DatePickerAltProps {
	value: number;
	onChange: (date: number | null) => void;
	isMobile?: boolean;
	placeholder?: string;
	utc?: boolean;
	datePickerProps?: any;
	yearsSelectOptions?: Array<number>;
	useDefaultFormat?: boolean;
	maxToday?: boolean;
	minToday?: boolean;
}

const isDateSupported = () => {
	const input = document.createElement('input');
	const value = 'a';
	input.setAttribute('type', 'date');
	input.setAttribute('value', value);
	return (input.value !== value);
};

/**
 * Adaptive Datepicker with using select from antd
 * */
const Datepicker: React.FC<DatePickerAltProps> = (props) => {
	const {
		maxToday,
		minToday,
		isMobile: isMobileProps,
		...rest
	} = props;
	const isMobile = useMobileView(768);
	const [supportDate, setSupportDate] = React.useState(false);

	React.useEffect(() => {
		setSupportDate(isDateSupported());
	}, []);

	return (supportDate && (isMobileProps ?? isMobile)
		? (
			<NativeDatepicker
				minToday={minToday}
				maxToday={maxToday}
				value={rest.value}
				onChange={rest.onChange}
				placeholder={props.placeholder}
			/>
		)
		: (
			<DatePickerReact
				{...props}
			/>
		));
};

export default Datepicker;
